<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form action>
      <div class="modal-card" style="width: 800px;">
        <header class="modal-card-head">
          <p class="modal-card-title" style="color: whitesmoke;">{{title}}</p>
        </header>

        <section class="modal-card-body">
          <staffSearch
            ref="staffList"
            v-bind:office-code="office"
            v-bind:office-master-list="referenceEnableOfficeList"
          />
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="save">決定</button>
          <button class="button" type="button" @click="close()">閉じる</button>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import StaffSearchTemplate from "../AppSelectStaff";

export default {
  props: ["officeCode", "officeMasterList", "value","title"],

  components: {
    staffSearch: StaffSearchTemplate
  },

  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      const staffInfo = this.$refs.staffList.getStaff();
      this.staffCode = staffInfo.staffCode;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      const newStaffoffice = staffInfo.officeCode;
      const newStaffofficeName = staffInfo.officeName;
      const id = staffInfo.id;
      this.setStaffs(
        this.officeCode,
        this.staffCode,
        this.staffName,
        newStaffoffice,
        newStaffofficeName,
        id,
      );
    },

    setStaffs: function(officeCode, staffCode, staffName, newStaffoffice, newStaffofficeName, id) {
      // 選択された担当者情報を親画面に返却
      this.$emit(
        "staff-change-event",
        {
          officeCode,
          staffCode,
          staffName,
          newStaffoffice,
          newStaffofficeName,
          id,
        }
      );
      this.close();
    },

    close: function() {
      this.$emit("input", false);
      return;
    }
  },

  data() {
    const office = this.$props.officeCode;
    const referenceEnableOfficeList = this.$props.officeMasterList;
    return {
      office,
      referenceEnableOfficeList
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/StaffChooser.vue